/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Route, Routes} from 'react-router-dom'
import {Team} from './components/team'
const TeamPage = () => (
  <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
    <Routes>
      <Route>
        <Route path='team' element={<Team />} />
      </Route>
    </Routes>
  </div>
)

export {TeamPage}
